import React from 'react';

import { IAppContext } from "./IAppContext";
import { SmokeApi } from "../controller/SmokeApi";
import { WebApiInterop } from "../controller/WebApiInterop";
import { AuthenticationResult, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../authConfig';

export class AppContext implements IAppContext
{
    m_webApiInterop: WebApiInterop;
    m_webApi: SmokeApi;

    constructor(msalInstance?: IPublicClientApplication)
    {
        this.m_webApiInterop = new WebApiInterop("https://smoking-api.azurewebsites.net", this, msalInstance);
        //this.m_webApiInterop = new WebApiInterop("http://localhost:7152", this, msalInstance);
        this.m_webApi = new SmokeApi(this.m_webApiInterop);
    }

    error(message: string[], title?: string): void
    {
        alert(`${message.join("\n")}`);
    }

    get WebApi(): SmokeApi
    {
        return this.m_webApi;
    }

    setAuth(token: string): void
    {
        this.m_webApiInterop.setAuth(token);
    }

    setMsalInstance(msalInstance: IPublicClientApplication): void
    {
        this.m_webApiInterop.setMsalInstance(msalInstance);
    }
}

export const TheAppContext = React.createContext(new AppContext());

